import { render, staticRenderFns } from "./PatientDetailConsultationsItem.vue?vue&type=template&id=0453332f&scoped=true"
import script from "./PatientDetailConsultationsItem.vue?vue&type=script&lang=js"
export * from "./PatientDetailConsultationsItem.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailConsultationsItem.vue?vue&type=style&index=0&id=0453332f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0453332f",
  null
  
)

export default component.exports